import Year from "./Year";
import Month from "./Month";
import Day from "./Day";

export default {
  Year,
  Month,
  Day,
};

export { default as Year } from "./Year";
export { default as Month } from "./Month";
export { default as Day } from "./Day";
